import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c5fa8d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "schedule-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortByMenu = _resolveComponent("SortByMenu")!
  const _component_TagSelect = _resolveComponent("TagSelect")!
  const _component_SearchBar = _resolveComponent("SearchBar")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_SortByMenu, { category: _ctx.category }, null, 8, ["category"]),
      _createVNode(_component_TagSelect, {
        title: "Tag",
        selectItems: _ctx.selectItems
      }, null, 8, ["selectItems"])
    ]),
    _createVNode(_component_SearchBar, {
      route: this.route
    }, null, 8, ["route"])
  ]))
}